// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"86":"f45928e1","433":"6287a28a","811":"89ac166d","840":"3f8e8d0e"}[chunkId] + ".css";
};